import { adminFetch } from "./_client";
import type { ContentArea, SiteContent, ConfigSetting } from "./types";


export function fetchSiteContent(token: string, page = 1, contentArea?: ContentArea) {
  const params = new URLSearchParams({ page: String(page) });
  if (contentArea) params.set("content_area", contentArea);
  return adminFetch<{ items: SiteContent[]; total: number }>(`/admin/content?${params}`, token);
}


export function upsertSiteContent(token: string, data: { id?: number; slug: string; title: string; body: string; content_type: string; content_area?: ContentArea; locale: string; is_published: boolean }) {
  return adminFetch<SiteContent>("/admin/content", token, { method: "POST", body: JSON.stringify(data) });
}


export function deleteSiteContent(token: string, id: number) {
  return adminFetch<{ success: boolean }>(`/admin/content/${id}`, token, { method: "DELETE" });
}


export function fetchEmailSettings(token: string) {
  return adminFetch<{ settings: ConfigSetting[] }>("/admin/email-settings", token);
}


export function updateEmailSettings(token: string, settings: { key: string; value: string }[]) {
  return adminFetch<{ success: boolean; errors: string[] }>("/admin/email-settings", token, {
    method: "PUT",
    body: JSON.stringify({ settings }),
  });
}


export function fetchSocialSettings(token: string) {
  return adminFetch<{ settings: ConfigSetting[] }>("/admin/social-settings", token);
}


export function updateSocialSettings(token: string, settings: { key: string; value: string }[]) {
  return adminFetch<{ success: boolean; errors: string[] }>("/admin/social-settings", token, {
    method: "PUT",
    body: JSON.stringify({ settings }),
  });
}


export function fetchLogsSettings(token: string) {
  return adminFetch<{ settings: ConfigSetting[] }>("/admin/logs-settings", token);
}


export function updateLogsSettings(token: string, settings: { key: string; value: string }[]) {
  return adminFetch<{ success: boolean; errors: string[] }>("/admin/logs-settings", token, {
    method: "PUT",
    body: JSON.stringify({ settings }),
  });
}
